import type { DesktopGridItem, ShortcutGroup } from 'shared/types/desktop-grid'

export type LayoutMode = 'desktop' | 'sequential'

export type BaseLayout = {
  position: { row: number; col: number }
  size: { width: number; height: number }
  grid: { cols: number }
  order: number
}

export type ReflowOptions = {
  fitRows?: number
  containerWidth?: number
  groups?: ShortcutGroup[]
}

export type LayoutPlacementResult = {
  items: DesktopGridItem[]
  needsHorizontalScroll: boolean
  needsVerticalScroll: boolean
  requiredCols: number
  requiredRows: number
}
